import { useState } from 'react';
import { useLang } from 'hooks/lang';

import { ProjectIssueUserType } from 'entities';

import { DropdownMenu, DropdownMenuItem } from 'components/Blocks';
import { PlusIcon, TagIcon, WrenchIcon } from 'components/Icons';

import { AddModal } from './AddModal';

import { BaseProps } from '../types';

export function AddUser(props: Pick<BaseProps, 'issue' | 'updateIssue'>) {
  const { t } = useLang();

  const [type, setType] = useState<ProjectIssueUserType | null>(null);

  return (
    <>
      <AddModal {...props} type={type} close={() => setType(null)} />

      <DropdownMenu triggerIcon={<PlusIcon size={14} />} align="start">
        <DropdownMenuItem onClick={() => setType('SALES')}>
          <TagIcon /> {t('sales')}
        </DropdownMenuItem>

        <DropdownMenuItem onClick={() => setType('EXECUTOR')}>
          <WrenchIcon /> {t('executors')}
        </DropdownMenuItem>
      </DropdownMenu>
    </>
  );
}
